import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ADD_CHECKLIST_VERSION_MUTATION,
  CREATE_CHECKLIST_MUTATION,
} from 'src/graphql/checklist/mutation';
import { noop } from 'src/utils/core/event';
import { notification } from 'src/components/Notification';
import { useMutation } from 'src/graphql';

export default (isNew, onSave = noop, setSaveError = noop) => {
  const { t } = useTranslation();

  const mutation = isNew
    ? CREATE_CHECKLIST_MUTATION
    : ADD_CHECKLIST_VERSION_MUTATION;
  const [upsertChecklist] = useMutation(mutation);

  const [isLoading, setIsLoading] = useState(false);

  const saveUpsertChecklistCallback = useCallback(
    async ({
      checklistId,
      checklistSections,
      effectiveDate,
      oldEffectiveDate,
      ...rest
    }) => {
      setIsLoading(true);

      try {
        const response = await upsertChecklist({
          variables: {
            checklistId,
            checklistSections: (checklistSections || []).map(
              ({ parentOriginalPosition, questions, ...section }) => ({
                ...section,
                questions: (questions || []).map(
                  ({ nestingLevel, ...question }) => question,
                ),
              }),
            ),
            effectiveDate: effectiveDate || null,
            oldEffectiveDate: oldEffectiveDate || null,
            ...rest,
          },
        });

        if (!response.data) {
          notification.error(t('SAVE_ERROR'));
        } else {
          onSave(response.data);
        }

        setSaveError(false);
      } catch (e) {
        notification.error(t('SAVE_ERROR'));
        setSaveError(true);
      }

      setIsLoading(false);
    },
    []
  );

  return {
    isLoading,
    saveUpsertChecklistCallback,
  };
};
